import React from "react";
import {FaDiscord} from  "react-icons/fa"
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillYoutube
} from "react-icons/ai";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={9} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body"><b className="purple">I am an advanced astronomy Discord bot that provides over 22 commands, helping you keep track of what's happening in space.</b>
              <br />One of the best science-based astronomy bot you can find on Discord.
              <br />
            </p>
          </Col>

          <Col md={10} className="home-about-description">
            <h1 style={{ textAlign: "justify", fontSize: "2em" }}>
            DETAILS:  </h1>
            <p style={{ textAlign: "justify" }}>
            <br />Developer:<span className="purple"> R2#8184 (astro_solutions)</span>
            <br />Started project on:<span className="purple"> Tuesday, February 15, 2022</span>
            <br />Programming language:<span className="purple"> Python (3.9)</span>
            <br />Discord client API libary:<span className="purple"> Nextcord</span>
            <br />Average response latency:<span className="purple"> 106 ms</span>
          </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
          <br /><br /><br />
            <p>
              Feel free to <span className="purple">contact </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://discord.gg/XX9p5qUkuj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/sotkrist"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
              <a
                href="https://www.youtube.com/channel/UCvgWKK9iDc4drrBLDpSehhA"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <  AiFillYoutube />
              </a>
              </li>
            </ul>
          </Col>
          <Col md={8} className="home-about-description">
            <h1 style={{textAlign: "left", fontSize: "1em" }}>
              Cosmos version: <span className="purple">4.9.0</span>
              <br />
              Website version: <span className="purple">2.1.0</span>
            </h1>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
